
import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthProvider } from '../services/auth.provider';
import { Multitenant } from '../services/multitenant.provider';

@Injectable({providedIn: 'root'})
export class ExposesGuard  {

  constructor(private auth: AuthProvider, private router: Router, private multiTenant: Multitenant) { }

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const themeClass = this.multiTenant.getDomainClass();

    if (this.auth.logedWithNoProfiles()) {
      this.router.navigate(['creer-compte', 'etape-2']);
    } else if (this.auth.isPartiallyAuthenticated()) {
      this.router.navigate(['profiles']);
    } else {
      return true;
    }

    return false;
  }
}
